import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Typography } from "@mui/material";
import { Box, styled } from "@mui/system";
import bluehaloLogo from "../../assets/logos/bluehalo-tem.png";

const LoadingContent = styled(Box)(({ theme }) => ({
	maxWidth: "250px",
}));

export const Loading = () => {
	return (
		<Box className="flex-row justify-center align-center" width={"100vw"} height={"100vh"}>
			<LoadingContent className="animate-fade-in-out">
				<Box>
					<img src={bluehaloLogo} width="100%" alt="BlueHalo Logo" />
				</Box>
				<Box>Authentication in progress</Box>
			</LoadingContent>
		</Box>
	);
};

export const ErrorComponent = ({ error }) => {
	const errorMessage = error?.message || "Unknown error occurred";
	return <Typography variant="h5">An Error Occurred: {errorMessage}</Typography>;
};

// Auth0 Protected Page Component
const ProtectedPage = withAuthenticationRequired(
	({ children }) => <>{children}</>,
	{
		onRedirecting: () => <Loading />,
		returnTo: window.location.pathname,
	}
);

export default ProtectedPage;